import { Base_Url } from "../../Base Url/BaseUrl";
import { postApiWithAuthenticated, getListWithAuthenticated} from "../../Api Method/ApiMethod";


const ProjectBaseUrl = `${Base_Url}/project`;


export const GetProjectList = async (params) => {
  let url = `${ProjectBaseUrl}/getProjectList`;

  const res = await postApiWithAuthenticated(url, params);
  return res;
};

export const addUpdateProject = async (url = '', params) => {
    
  
    const res = await postApiWithAuthenticated(`${ProjectBaseUrl}${url}`, params);
    return res;
  };

//   const res = await postApiWithAuthenticated(`${ProjectBaseUrl}${url}`, params);
//   return res;
// };

export const changeProjectStatus = async (id) => {
  let url = `${ProjectBaseUrl}/changeProjectStatus?ProjectKeyID=${id}`;
  const res = await getListWithAuthenticated(url);
  return res;
};


export const GetProjectModelData = async (id) => {
    let url = `${ProjectBaseUrl}/getProjectModel?ProjectKeyID=${id}`;
  
    const res = await getListWithAuthenticated(url);
    return res;
  };
export const getAllProjectList = async (id) => {
    let url = `${ProjectBaseUrl}/getAllProjectList?ProjectCatKeyID=${id}`;
  
    const res = await getListWithAuthenticated(url);
    return res;
  };


export const GetGalleryCatLookupList = async () => {
    const url = `${ProjectBaseUrl}/GallaryCatLookup`;
  
    const res = await getListWithAuthenticated(url );
    return res;
  };
  
//   export const ChangeStateStatus = async (id,UserKeyID) => {
//     let url = `${ProjectBaseUrl}/ChangeStateStatus?StateID=${id}&UserKeyID=${UserKeyID}`;
//     const res = await getListWithAuthenticated(url);
//     return res;
//   };